import { safeRedirect } from './safeRedirect';

export type InternalLocation = { to: string; search?: Record<string, string>; hash?: string };

// A remembered target is a whole path — `/reimbursement/<uuid>?from=newRequests`, say — but the router's `to`
// is a pathname and nothing else: `resolvePath` splits it on '/' and never looks for '?' or '#'. Handed the
// string whole, the query becomes part of the last path segment, so `$offerRequestLeadUuid` captures
// `<uuid>?from=newRequests` and the page loads against a corrupt id. Split it before navigating.
export function toInternalLocation(path: string | undefined, fallback = '/'): InternalLocation {
    // The base is inert: `safeRedirect` has already rejected anything that is not an app-internal path.
    const url = new URL(safeRedirect(path, fallback), 'http://internal.invalid');
    const search = Object.fromEntries(url.searchParams);
    return {
        to: url.pathname,
        ...(Object.keys(search).length > 0 ? { search } : {}),
        ...(url.hash ? { hash: url.hash.slice(1) } : {}),
    };
}
